export default {
  scoreBox: {
    fiinTradeRank: 'FiinTrade Xếp Hạng',
    basicMaterials: 'Vật liệu Cơ Bản', //không cố định, đây là ngành của ticker
    score: 'Đánh giá',
    value: 'Giá trị',
    growth: 'Tăng trưởng',
    momentum: 'Động lực',
    vgm: 'VGM',
  },
  rankingTooltip: {
    oneLine: 'Xếp hạng cổ phiếu theo ngành và',
    twoLine: 'theo nhóm VN30, VNMidcap, VNSmall',
  },
  scoreTooltip: {
    oneLine: 'Đánh giá cổ phiếu theo ngành và',
    twoLine: 'theo nhóm VN30, VNMidcap, VNSmall',
  },
  LOWEST: 'THẤP NHẤT',
  HIGHEST: 'CAO NHẤT',
};
